import { ElephantPresetType } from '@aibees/elephant/types';
import { TemplateColumns } from '@aibees/shared/features';
import { useMemo } from 'react';
import { useExportOptions } from './use-export-options';
import { useExportTemplateDataType } from './use-export-template-data-type';

export function useExportTemplateDefaultItem() {
  const dataType = useExportTemplateDataType();
  const { peopleOptions, companyOptions } = useExportOptions();

  return useMemo(() => {
    const templateCompanyColumns: TemplateColumns = {
      categoryWithNoChildren: true,
      items: companyOptions
        ? [{ ...companyOptions, name: 'Company Basic' }]
        : [],
    };

    const templatePeopleColumns: TemplateColumns = {
      information: {
        key: 'PROFILE_INSIGHT',
        description:
          'Fields with this icon come from Profile Insight. If enabled in your export settings, they will be filled; otherwise, they will appear empty in your CSV. Ensure your export settings match your template to avoid blank columns.',
        title: 'Requires Profile Insight Enabled',
        icon: 'badge-outline',
      },
      items: peopleOptions,
    };

    return dataType ===
      ElephantPresetType.COMPANY_SEARCH_EXPORT_SETTINGS_COLUMNS
      ? templateCompanyColumns
      : templatePeopleColumns;
  }, [dataType, peopleOptions, companyOptions]);
}
